// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import rem from './assets/js/rem.js'
import 'babel-polyfill'
import axios from 'axios'
Vue.use(elementUI).use(VueAwesomeSwiper);
Vue.prototype.rem = rem
Vue.prototype.formatteTime = function (params) {
  let dt = new Date(params * 1000)
  let year = dt.getFullYear()
  let month = dt.getMonth() + 1
  let day = dt.getDate()
  return `${year}年${month > 10 ? month : '0' + month}月${day > 10 ? day : '0' + day}日`
}
Vue.config.productionTip = false
// axios.defaults.baseURL = 'http://dudaozb.b.langqiyun.cn/api/'
axios.defaults.baseURL = 'http://admin.retaon.com/api/'
axios.interceptors.response.use(

  response => {
    try {
      if (response.data.data.data.length == 0) {
        elementUI.Message.info('没有更多了')
      }
    } catch (error) {
    }
    return Promise.resolve(response.data.data)


  }
)
Vue.prototype.axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js